import {Pipe, PipeTransform} from '@angular/core';
import {Lottery} from "../model/lottery";
import {getFullAddress} from "lottery-shared";

@Pipe({
  name: 'apartmentAddress',
  standalone: true
})
export class ApartmentAddressPipe implements PipeTransform {
  transform(apartment: Lottery): string {
    return getFullAddress(apartment.addressInfo);
  }

}
